module.exports = __webpack_public_path__ + "fonts/FuturaPT-Book.780bbcf9.woff2";